import { Component, Input, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { UI } from '../../components/ui';
import { DynamicListComponent } from '@mm-aggregator/drf-dynamics';
import type { EntityConfig } from '../../config/entity-config';
import { RoleAccessService } from '../../services/role-access.service';
import { ShellRoutesService } from '../../services/shell-routes.service';

/**
 * List page for an entity: optional slots (above, below, start, end) and the dynamic list.
 * Custom list components can use this and project content into the slots.
 */
@Component({
  selector: 'app-entity-list-page',
  standalone: true,
  imports: [DynamicListComponent, RouterLink, ...UI],
  templateUrl: './entity-list-page.component.html',
})
export class EntityListPageComponent {
  @Input() entityConfig!: EntityConfig;
  /** Fixed filters sent with every list request (e.g. from dashboard click-throughs). */
  @Input() extraQueryParams: Record<string, string | number> = {};

  readonly roleAccess = inject(RoleAccessService);
  readonly shellRoutes = inject(ShellRoutesService);

  constructor(private readonly router: Router) {}

  get listPath(): string {
    return this.entityConfig?.listPath ?? '';
  }

  get title(): string {
    return this.entityConfig?.label ?? 'List';
  }

  get entityKey(): string {
    return this.entityConfig?.key ?? '';
  }

  onRowSelect(row: Record<string, unknown>): void {
    const id = row['id'] ?? row['pk'];
    if (id != null) {
      void this.router.navigate(this.shellRoutes.commands('manage', this.entityKey, String(id)));
    }
  }
}
